import { type Account } from '@reliance/types/models/Itds';
import { type ApiSuccessResponse, type ApiService } from '../types/ApiService';

export const itds = (siteApi: ApiService) => ({
  post: (data): Promise<ApiSuccessResponse<object>> => {
    return siteApi.post('/itds', data);
  },
  delete: (account, data): Promise<ApiSuccessResponse<object>> => {
    return siteApi.delete(`/itds/${account}`, { data });
  },
  get: (params): Promise<Account> => {
    return siteApi.get('/itds', { params });
  },
});
